<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <div class="row" :style="fblabelposition == 'right'? 'flex-direction: row-reverse;': ''">
      <div
        class="col-form-label"
        :class="fblabelposition == 'top' ? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12 text-center' : fblabelposition == null|| undefined || '' ? 'col-sm-12' :'col-sm-2'"
        v-if="fbhidelabel !== 'true'"
      >
        <label>
          <b style="color: red;" v-if="fbrequired == 'true'">*</b>
          {{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}
        </label>
      </div>
      <div
        :class="fblabelposition == 'top'? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12' : (fblabelposition == null || undefined || '')? 'col-sm-12' : 'col-sm-10'"
      >
        <input
          :data-inputmask="fbinputmask"
          ref="input"
          type="text"
          :placeholder="fbplaceholder"
          :value="value"
          class="form-control"
          :class="{ invalid: isValid === false }"
          :required="fbrequired == 'true' ? true : false"
          autocomplete="nope"
          :readonly="checkReadonly(isedit, fbreadonly)"
          :step="getStep(fbmaxlength)"
        />
        <span v-if="fbhelptext" class="form-text text-muted">{{ fbhelptext }}</span>
        <!-- :max="getMaxValue(fbmaxlength)" -->
        <!-- <label v-if="isValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ this.errormessage || $t('ui.SYS00016') }}</label>
        <label v-if="isFormatValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ $t('message.SYS00002', { digit: digit, decimal: decimal }) }}</label>-->
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import helper from "@/vueHelper";
import Inputmask from "inputmask";

export default {
  name: "Number",
  props: [
    "id",
    "fbsupportmultiplelanguages",
    "value",
    "fblabel",
    "fbplaceholder",
    "fbvalue",
    "fbtype",
    "fbtypedetail",
    "fbinvisible",
    "fbmaxlength",
    "fbdecimalplaces",
    "format",
    "fbreadonly",
    "fblabelposition",
    "labelwidth",
    "fbrequired",
    "fbhidelabel",
    "fbhelptext",
    "errormessage",
    "allowedInput",
    "type",
    "blurValidation",
    "isedit",
    "fbinputmask"
  ],
  data() {
    return {
      isValid: true,
      isFormatValid: true,
      digit: 0,
      decimal: 0,
      beforeEditValue: null
    };
  },
  mounted() {
    let $vm = this;
    $vm.$emit("input", this.fbvalue, this);


    if ($vm.value != null) {
      $vm.$emit("input", this.value, this);
    }

    $($vm.$refs.input).on("keypress", function(e) {
      let data = $($vm.$refs.input).val();
      let digit = parseInt($vm.fbmaxlength.split(",")[0]) - parseInt($vm.fbmaxlength.split(",")[1]) || parseInt($vm.fbmaxlength);

      console.log(data);
      console.log(e.key);
      if (data.length >= digit || (isNaN(e.key) && e.key != '.')) {
        console.log('reached here');
        return false;
      }
    }).on('change', function(e){
      let digit = $vm.fbmaxlength.split(',')[1];
      if(digit){      
        let value = parseFloat($(e.target).val()).toFixed(digit);
        $(e.target).val(value);
        $vm.$emit("input", value, this);
      }else{
        $vm.$emit("input", $(e.target).val(), this);
      }
    })

    if($vm.fbinputmask){
      Inputmask().mask($vm.$refs.input);
    }

    if($vm.fbtype == "dateDifference"){
      console.log($vm.value)

    }
  },
  methods: {
    setFocus() {
      this.$refs.input.focus();
    },
    setValid(val) {
      this.isValid = val;
    },
    setFormatValid(val) {
      this.isFormatValid = val;
    },
    isFieldValid() {
      var val = $(this.$refs.input).val();
      return (
        !this.fbrequired ||
        (this.fbrequired && val !== null && val !== undefined && val !== "")
      );
    },
    isFieldFormatValid() {
      return !this.format || (this.format && this.matchFormat());
    },
    matchFormat() {
      // Make sure the value matches format given
      if (!$(this.$refs.input).val() || !this.format) {
        return true;
      }

      // var f = this.format.split(',')

      // var re = new RegExp('^(\\d){0,' + f[0] + '}(\\.(\\d){0,' + (f.length > 1 ? f[1] : '0') + '})?$', 'igm')
      var re = new RegExp(this.format, "igm");
      return re.test($(this.$refs.input).val());
    },
    resetValue() {
      this.isValid = true;
      $(this.$refs.input).val(null);
    },
    checkReadonly(isedit, fbreadonly) {
      let readonly = true;
      if (isedit) {
        if (fbreadonly == "true") {
          readonly = true;
        } else {
          readonly = false;
        }
      } else {
        readonly = true;
      }
      return readonly;
    },
    getStep(maxlength) {
      let format = maxlength;
      let return_value = 1;
      if (format) {
        let length = format.split(",")[0];
        let decimal_places = format.split(",")[1];
        for (let i = 0; i < decimal_places; i++) {
          return_value = return_value / 10;
        }
      }
      return return_value;
    },
    getMaxValue(maxlength) {
      let format = maxlength;
      let return_value = 10;
      let minus_value = 1;
      if (format) {
        let length = format.split(",")[0];
        let decimal_places = format.split(",")[1] || 0;
        let digit = length - decimal_places;
        return_value = 10 ** digit;
      }
      return return_value;
    },

  },
  computed: {
    labelCol() {
      return this.labelwidth || 3;
    }
  }
};
</script>
